import { useMemo } from "react";
import { ClockLoader, PenIcon } from "../../../../assets/icons";
import { AssessmentStatus, STATUS_CONFIG } from "../../../../model/leads/leads";

import styles from "../RequestPage.module.scss";

export const getStatusConfig = (status: AssessmentStatus) => {
	return (
		STATUS_CONFIG[status] || {
			cssClass: "status_badge_progress",
			text: "Unknown Status",
			canChange: false,
		}
	);
};

export const AssessmentStatusBadge = ({
	status,
	onChangeStatus,
}: {
	status: AssessmentStatus;
	onChangeStatus: () => void;
}) => {
	const config  =  useMemo(() => {
     return getStatusConfig(status);
	},[status]) 

	return (
		<div className={styles.details_row}>
			<span className={styles.details_label}>Physical Load Assessment Status</span>
			<span className={`${styles.details_value} ${styles.row}`}>
				<span className={`${styles.status_badge} ${styles[config.cssClass]}`}>
					<ClockLoader /> {config.text}
				</span>
				{config.canChange && <button className={styles.button} onClick={onChangeStatus} disabled={false} type="button">
					<PenIcon color="#1C1B1F" />
					<span>Change Status</span>
				</button>}
			</span>
		</div>
	);
};
